import CloseIcon from '@material-ui/icons/Close';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import mobileMenu from '../../../assets/images/mobile-menu.svg';
import MobileNav from '../mobileNav/MobileNav';
import Header from './Header/header';
import styles from './TopBar.module.scss';

const TopBar = props => {
  let history = useHistory();
  const [isMobileMenuOpen, setMobileMenuVisibility] = useState(false);
  const isHomePage = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const location = useLocation();
    const isNewTab = location?.search.includes('tab');
    return (
      location.pathname !== '/' &&
      location.pathname !== '/qr' &&
      location.pathname !== '/finished' &&
      !isNewTab
    );
  };

  return (
    <div>
      <div>
        <div className={`container ${styles.mobileBack}`}>
          {isHomePage() ? (
            <button
              onClick={() => {
                history.goBack();
              }}
            >
              Back
            </button>
          ) : null}
        </div>
        <Header />
      </div>
      <div className={styles.sticky}>
        <div className={`container d-flex  ${styles.navBar}`}>
          <h1>
            <NavLink to={'/'}>Australian Death Notification Service</NavLink>
          </h1>
          <nav className={styles.desktopNav}>
            <NavLink activeStyle={{ color: '#447b75' }} to={'/participating-organisations'}>
              Participating organisations
            </NavLink>
            <NavLink activeStyle={{ color: '#447b75' }} to={'/support'}>
              Support services
            </NavLink>
            <NavLink activeStyle={{ color: '#447b75' }} to={'/help-centre'}>
              Help centre
            </NavLink>
          </nav>
          {!isMobileMenuOpen ? (
            <button
              className={styles.button + ' ' + styles.burgerMenu}
              onClick={() => setMobileMenuVisibility(true)}
              onKeyPress={event => {
                console.log(event.which);
                if (event.which == 13) {
                  setMobileMenuVisibility(true);
                }
              }}
            >
              <img src={mobileMenu} alt={`Menu`} className={styles.menuIcon} />
            </button>
          ) : (
            <button className={styles.button}>
              <CloseIcon className={styles.menuIcon} />
            </button>
          )}
        </div>

        {isMobileMenuOpen && (
          <div className={`mobileNav`}>
            <MobileNav
              isMobileMenuOpen={isMobileMenuOpen}
              setMobileMenuVisibility={setMobileMenuVisibility}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TopBar;
